// =====================================================
// 📁 POSProductAddButton.tsx
// =====================================================

import { ShoppingCart } from 'lucide-react';

interface Props {
  onClick?: () => void;

  fullWidth?: boolean;

  disabled?: boolean;

  size?: 'sm' | 'md';

  label?: string;
}

const POSProductAddButton = ({
  onClick,

  fullWidth = false,

  disabled = false,

  size = 'md',

  label = 'Agregar',
}: Props) => {
  // =====================================================
  // 🎨 Sizes
  // =====================================================
  const sizeStyles = {
    sm: `
      h-[38px]
      px-4
      text-sm
    `,

    md: `
      h-[42px]
      px-5
      text-sm
    `,
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
      inline-flex
      items-center
      justify-center
      gap-2

      rounded-xl

      bg-primary

      font-medium
      text-white

      shadow-sm

      transition-all
      duration-200
      ease-out

      hover:bg-primary/90
      hover:shadow-md

      focus-visible:outline-none

      focus-visible:ring-2
      focus-visible:ring-primary/25
      active:scale-[0.99]

      disabled:cursor-not-allowed
      disabled:bg-primary/50
      disabled:text-white/80
      disabled:shadow-none
      disabled:hover:bg-primary/50
      disabled:hover:shadow-none
      disabled:active:scale-100

      ${sizeStyles[size]}

      ${fullWidth ? 'w-full' : ''}
    `}
    >
      <ShoppingCart
        className="
        h-4
        w-4
        shrink-0
      "
      />

      <span className="truncate">{label}</span>
    </button>
  );
};

export default POSProductAddButton;
